<template>
  <div id="video" ref="miniVideo">
    <div
      class="video-wrap"
      ref="video_wrap"
      @mouseleave="videoLeave"
      @mousemove="videoMove($event)"
    >
      <template v-if="isLive">
        <div id="dplayer" :key="playSrc" v-show="!playSrcChange"></div>
        <!-- <div id="my-video"></div> -->
        <!-- <video id="myVideo" :poster="poster" autoplay ref="video" preload="auto">
                    <source :src="playSrc" type="application/x-mpegURL" />
                </video> -->
        <!-- <div id="ckplayer"></div> -->
        <!-- <video id="myVideo" class="video-js" ref="myVideo">
                    <source :src="playSrc" :type="myVideoType.type">
                </video> -->
        <!-- <el-image v-if="isLoading&&isSuccess" style="width: 64px;height: 14px;position: absolute;top: 50%;left: 50%;margin-top: -7px;margin-left: -32px;z-index: 1;" src="/static/./../assets/images/base/loading.gif"></el-image> -->
        <!-- <video id="videoplayer" :poster="poster" autoplay ref="video" preload="auto"></video> -->
      </template>
      <template v-if="!isLive && !playSrcChange">
        <video
          v-if="autoplay"
          :poster="poster"
          autoplay
          ref="video"
          :src="playSrc"
          preload="auto"
        ></video>
        <video
          v-else
          :poster="poster"
          ref="video"
          :src="playSrc"
          preload="auto"
        ></video>
      </template>
      <div class="no-success" v-if="(!isSuccess && !isError) || playSrcChange">
        <div class="wrap">
          <div class="logo-living"></div>
          <!-- <img class="logo-living" src="./../assets/images/logo.png" alt="logo"> -->
          <div class="icon"></div>
          <p class="loading-words">{{ $t("video.loading") }}</p>
          <p class="msg">
            {{ $t("video.download_app")
            }}{{ isLive ? $t("video.more_live") : $t("video.more_video") }}
          </p>
        </div>
        <div
          style="display: inline-block; vertical-align: middle; height: 100%"
        ></div>
      </div>
      <div
        class="no-success error"
        v-if="isError && !isSuccess && !playSrcChange"
      >
        <div class="wrap">
          <span class="icon"></span>
          <p class="msg">{{ $t("video.link_failed") }}</p>
          <el-button @click="onRestart">{{ $t("video.reload") }}</el-button>
        </div>
        <div
          style="display: inline-block; vertical-align: middle; height: 100%"
        ></div>
      </div>
      <i
        class="video-play-icon"
        v-show="!isPlay && isSuccess && !isError"
        @click="play"
      ></i>
      <div
        class="video-btn-wrap"
        :class="{ show: isShowCon, hide: !isShowCon }"
        v-if="!isError && isSuccess"
      >
        <el-slider
          v-if="!isLive"
          class="time-slider"
          v-model="time"
          :format-tooltip="timeFormatTooltip"
          @change="saveTime"
        ></el-slider>
        <div class="video-btn-left">
          <i
            class="icon-btn"
            v-show="isPlay"
            @click="stopPlay"
            @mouseenter="enterPlay"
            @mouseleave="leavePlay"
          ></i>
          <i
            class="icon-btn"
            v-show="!isPlay"
            @click="play"
            @mouseenter="enterPlayS"
            @mouseleave="leavePlayS"
          ></i>
          <i v-if="isLive" class="icon-btn" @click="onRestart"></i>
          <i
            class="icon-btn"
            :class="mute ? 'mute' : ''"
            @click="onMute"
            @mouseenter="enterMute"
            @mouseleave="leaveMute"
          ></i>
          <el-slider v-model="volume" @input="saveVolume"></el-slider>
          <span v-if="!isLive" class="time-info">{{
            timeTxt + "/" + timeDurTxt
          }}</span>
        </div>
        <div class="video-btn-middle">
          <span class="play-or-stop" ref="playOrStop">{{ playOrS }}</span>
          <span class="mute-or-sound" ref="muteOrSound">{{ muteOrS }}</span>
        </div>
        <div class="video-btn-right">
          <div class="danmu">
            <span>{{ $t("video.danmu") }}</span>
            <el-switch
              v-model="isDanmu"
              :active-color="'var(--primary-color)'"
              @change="onDanmu"
            >
            </el-switch>
          </div>
          <!-- <i v-if="$route.name !== 'home'" class="icon-btn" :class="{hiddle: !isDanmu}" @click="onDanmu"></i> -->
          <ul class="clarity" v-show="isClarity">
            <li
              class="clarity-item"
              v-for="(item, index) in clarity"
              :key="index"
              :class="index === activeClarify ? 'active' : ''"
              @click="selectClarity(index)"
            >
              {{ item.name }}
            </li>
          </ul>
          <div class="select-clarity" @click.stop="isClarity = !isClarity">
            {{ clarity[activeClarify].name }}
          </div>
          <div class="fullScreen-or-no" ref="fullOrNo">{{ fullScreenN }}</div>
          <i
            class="icon-btn"
            :class="isFullScreen ? 'full' : ''"
            @click="onFullScreen"
            @mouseenter="enterScreeen"
            @mouseleave="leaveScreeen"
          ></i>
        </div>
      </div>

      <div class="videoLogo"></div>
      <div class="videoLogo"></div>
      <div class="videoLogo"></div>
      <div class="videoLogo"></div>
      <div id="barragediv" v-show="isDanmu">
        <div id="barrageLayer0"></div>
        <div id="barrageLayer1"></div>
        <div id="barrageLayer2"></div>
        <div id="barrageLayer3"></div>
      </div>
      <!-- <p v-if="isError" class="error">{{errorText}}</p> -->
      <router-link
        v-show="!miniMark && homeLive && isSuccess && !playSrcChange"
        class="enter-studio"
        :to="'/liveDetails/' + liveUid + '-' + liveStream"
        >{{ $t("video.enterStudio") }}</router-link
      >
    </div>
    <div
      class="min-mark"
      ref="minMark"
      v-show="miniMark"
      @click="minStopOrPlay"
    >
      <div class="min-content" v-show="miniShow">
        <div class="min-top">
          <div class="top-left">按住视频可进行拖动</div>
          <div class="top-right" @click.stop="closeMiniVideo"></div>
        </div>
        <div class="min-bottom">
          <i class="icon-stopplay" v-show="isPlay" @click.stop="stopPlay"></i>
          <i class="icon-play" v-show="!isPlay" @click.stop="play"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DPlayer from "dplayer";
export default {
  name: "Video",
  components: {},
  props: {
    autoplay: {
      type: Boolean,
      default: true,
    },
    poster: {
      type: String,
      default: "",
    },
    playSrc: {
      type: String,
      default: localStorage.getItem("pull"),
    },
    isLive: {
      type: Boolean,
      default: false,
    },
    homeLive: {
      type: Boolean,
      default: false,
    },
    liveUid: {
      type: String,
      default: "",
    },
    liveStream: {
      type: String,
      default: "",
    },
    playSrcChange: {
      type: Boolean,
    },
  },
  data() {
    return {
      logoImg: "", //直播logo图
      playOrS: "点击暂停",
      muteOrS: "点击静音",
      fullScreenN: "点击全屏",
      minMark: null,
      eleVideo: null,
      moveScreen: true,
      miniMark: false, //小窗上的按钮和字的背景div的显示与隐藏
      miniShow: false, //小窗上的按钮和字的显示与隐藏
      stopSrc: "",
      isClarity: false,
      isPlay: false,
      isError: false,
      mute: false,
      volume: 50,
      clarity: [
        // { name: "蓝光8M" },
        // { name: "蓝光4M" },
        // { name: "超清" },
        // { name: "高清" },
        // { name: "标清" }
        { name: "原画" },
      ],
      // activeClarify: 4,
      activeClarify: 0,
      isFullScreen: false,
      timeNow: 0,
      timeDuration: 0,
      time: 0,
      timeTxt: "",
      timeDurTxt: "",
      isSuccess: false,
      isLoading: true,
      myVideoType: "",
      isDanmu: true,
      errorText: "加载错误",
      isShowCon: false,
      flvPlayer: null,
      myPlayer: null,
      moveFlag: true,
      shakeTime: "",
      barrageIndex: 1, // 弹幕管道基数
    };
  },
  computed: {
    playObj() {
      return {
        playSrcChange: this.playSrcChange,
        playSrc: this.playSrc,
      };
    },
  },
  methods: {
    sendBarrage(msg) {
      //根据数组下标 创建对应通道的节点 这里也演示其中一个
      let idName = `barrageLayer${this.barrageIndex % 4}`;
      let barrageLayer = document.getElementById(idName);
      // 创建dom内容 定义dom style样式
      let divBox = document.createElement("span");
      // let divBoxText = document.createElement('span');
      divBox.setAttribute("class", "barrageDivClass");
      divBox.innerText = msg.msg;
      // 弹幕用户头像功能，后续看需求添加
      // let divBoxImg=document.createElement('span');
      // divBox.appendChild(divBoxImg);
      // divBoxImg.setAttribute('class','barrageDivClass_img');
      // divBoxImg.style.backgroundImage=`url(${imgUrl})`;
      // divBox.appendChild(divBoxText);
      divBox.style.left =
        document.getElementById("barragediv").clientWidth + "px"; // 初始化left位置,一开始在屏幕的右侧
      barrageLayer.appendChild(divBox);

      // 定时器移动dom，形成弹幕
      let time = null;
      let l = 0;
      this.barrageIndex++;
      time = setInterval(function () {
        if (msg.msg.length < 15) {
          // 这里可以根据需求自定义弹幕加载的速度
          l = l - 1;
        } else {
          l = l - 2;
        }
        //通过减少left属性移动这个div 从右往左移动
        divBox.style.left =
          document.getElementById("barragediv").clientWidth + l + "px";

        if (
          document.getElementById("barragediv").clientWidth + l <=
          0 - divBox.offsetWidth - 50
        ) {
          barrageLayer.removeChild(divBox); //移除dom
          clearInterval(time); //清除这个div的定时器
        }
      }, 20);
    },
    enterScreeen() {
      //鼠标移入全屏按钮
      this.fullScreenN = this.isFullScreen ? "退出全屏" : "点击全屏";
      this.$refs.fullOrNo.style.display = "block";
    },
    leaveScreeen() {
      //鼠标移出全屏按钮
      this.$refs.fullOrNo.style.display = "none";
    },
    enterMute() {
      //鼠标移入静音按钮
      this.muteOrS = this.mute ? "取消静音" : "点击静音";
      this.$refs.muteOrSound.style.display = "block";
    },
    leaveMute() {
      //鼠标移出静音按钮
      this.$refs.muteOrSound.style.display = "none";
    },
    enterPlayS() {
      //鼠标移入播放按钮
      this.playOrS = "点击播放";
      this.$refs.playOrStop.style.display = "block";
    },
    leavePlayS() {
      //鼠标移出播放按钮
      this.$refs.playOrStop.style.display = "none";
    },
    enterPlay() {
      //鼠标移入暂停播放按钮
      this.playOrS = "点击暂停";
      this.$refs.playOrStop.style.display = "block";
    },
    leavePlay() {
      //鼠标移出暂停播放按钮
      this.$refs.playOrStop.style.display = "none";
    },
    closeMiniVideo() {
      //点击关闭小窗视频按钮
      this.moveScreen = false;
      this.miniMark = false;
      this.miniShow = false;
      this.$refs.miniVideo.className = "";
    },
    handleScroll() {
      //监听页面滚动
      if (this.shakeTime || !this.moveScreen) {
        return;
      }
      this.shakeTime = setTimeout(() => {
        //监听页面滚动节流  优化性能
        var scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop >= 600 && !this.miniMark) {
          //当滑动距离顶部的距离大于600后出现mini视频窗口
          this.miniMark = true;
          this.eleVideo.className = "min-video";
          let This = this;
          this.minMark.addEventListener(
            "mouseover",
            function () {
              //监听鼠标划进播放框中
              This.miniShow = true;
            },
            false
          );
          this.minMark.addEventListener(
            "mouseout",
            function () {
              This.miniShow = false;
            },
            false
          );
          this.livingLogo();
        } else if (scrollTop < 600 && this.miniMark) {
          //当滑动距离顶部的距离小于600后出现mini视频窗口隐藏
          this.eleVideo.className = "";
          this.miniMark = false;
          this.miniShow = false;
          this.livingLogo();
        }
        this.shakeTime = "";
      }, 300);
    },
    dragMiniVideo() {
      //拖拽小视频窗口
      let This = this;
      let minMark = this.$refs.minMark,
        box = minMark.parentNode;
      minMark.onmousedown = function (e) {
        This.moveFlag = true;
        let disxy = e.pageX + "-" + e.pageY;
        let disx = e.pageX - box.offsetLeft;
        let disy = e.pageY - box.offsetTop;
        let disH = parseInt(getComputedStyle(minMark).height);
        let disW = parseInt(getComputedStyle(minMark).width);
        document.onmousemove = function (e) {
          if (e.pageY - disy < 0) {
            //如果上划进网页头部
            box.style.top = 0 + "px";
          } else if (e.pageY - disy > document.body.offsetHeight - disH) {
            //如果下划进网页低部
            box.style.top = document.body.offsetHeight - disH + "px";
          } else {
            box.style.top = e.pageY - disy + "px";
          }
          if (e.pageX - disx < 0) {
            box.style.left = 0 + "px";
          } else if (e.pageX - disx > document.body.offsetWidth - disW) {
            box.style.left = document.body.offsetWidth - disW + "px";
          } else {
            box.style.left = e.pageX - disx + "px";
          }
        };
        //释放鼠标按钮，将事件清空，否则始终会跟着鼠标移动
        document.onmouseup = function (e) {
          document.onmousemove = null;
          document.onmousedown = null;
          if (disxy !== e.pageX + "-" + e.pageY) {
            This.moveFlag = false;
          }
        };
      };
    },
    videoLeave() {
      window.videoMoveTimer && clearTimeout(window.videoMoveTimer);
      this.isClarity = this.isShowCon = false;
    },
    videoMove(event) {
      window.videoMoveTimer && clearTimeout(window.videoMoveTimer);
      this.isShowCon = true;
      window.videoMoveTimer = setTimeout(() => {
        this.isShowCon = false;
      }, 3000);
    },
    stopPlay() {
      this.isPlay = false;
      // this.isLive ? window.player.videoPause() : this.$refs.video.pause();
      this.isLive ? this.myPlayer.pause() : this.$refs.video.pause();
    },
    play() {
      // this.isPlay = true;
      // this.isLive ? window.player.videoPlay() : this.$refs.video.play();
      this.isLive ? this.myPlayer.play() : this.$refs.video.play();
    },
    onRestart() {
      if (this.isLive) {
        window.restartErrorTimer && clearTimeout(window.restartErrorTimer);
        window.restartStalledTimer && clearTimeout(window.restartStalledTimer);
        this.isSuccess = false;
        this.isLoading = true;
        this.isError = false;
        this.playSrcChange = false;
        let pausedEl = document.querySelector(".dplayer-paused");
        if (pausedEl) {
          let className = pausedEl.className;
          pausedEl.className = className.replace("dplayer-paused", "");
        }
        this.createDpayer();
      } else {
        this.$refs.video.load();
      }
      // this.isPlay = true;
    },
    dispose() {
      // window.player.removeChild();
      // window.player.videoClear();
      // this.myPlayer&&this.myPlayer.dispose();
      this.myPlayer && this.myPlayer.destroy();
      this.myPlayer = null;
      this.isSuccess = false;
    },
    toggleVideo(index) {
      this.activeIndex = index;
      // this.isPlay = true;
    },
    onMute() {
      let mute = !this.mute;
      this.volume = mute ? 0 : 50;
      this.muteOrS = mute ? "取消静音" : "点击静音";
      this.mute = mute;
      // this.isLive ? window.player.changeVolume(mute / 100) : this.$refs.video.volume = mute / 100;
      this.isLive
        ? this.myPlayer &&
          this.myPlayer.volume &&
          this.myPlayer.volume(mute / 100)
        : (this.$refs.video.volume = mute / 100);
    },
    onDanmu(val) {
      this.isDanmu = val;
    },
    turnTime(result) {
      var h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      if (isNaN(h)) h = "00";
      var m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      if (isNaN(m)) m = "00";
      var s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);
      if (isNaN(s)) s = "00";
      var time = Number(h) < 0 ? h + ":" + m + ":" + s : m + ":" + s;
      return time;
    },
    timeFormatTooltip(val) {
      // console.log(parseInt(this.timeDuration * (val / 100)))
      var time = this.turnTime(parseInt(this.timeDuration * (val / 100)));
      return time;
    },
    saveTime(val) {
      // console.log(val)
      // console.log(parseInt(this.timeDuration * (val / 100)))
      this.$refs.video.currentTime = parseInt(this.timeDuration * (val / 100));
    },
    saveVolume() {
      var volume = this.volume;
      this.mute = volume ? false : true;
      if (this.isLive) {
        this.$nextTick(() => {
          // window.player&&window.player.changeVolume(volume / 100);
          this.myPlayer &&
            this.myPlayer.volume &&
            this.myPlayer.volume(volume / 100);
        });
      } else {
        this.$refs.video.volume = volume / 100;
      }
      localStorage.setItem("volume", volume);
    },
    selectClarity(index) {
      this.activeClarify = index;
    },
    onFullScreen() {
      var isFullScreen = this.isFullScreen;
      if (isFullScreen) {
        this.exitFullscreen();
      } else {
        this.requestFullscreen(this.$refs.video_wrap);
        this.isFullScreen = true;
      }
    },
    requestFullscreen(ele) {
      // 全屏兼容代码
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },
    exitFullscreen() {
      // 取消全屏
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      }
      this.isFullScreen = false;
    },
    addEventListeners() {
      const self = this;
      self.$refs.video.addEventListener("timeupdate", self._currentTime),
        self.$refs.video.addEventListener("canplay", self._durationTime);
    },
    removeEventListeners() {
      const self = this;
      self.$refs.video.removeEventListener &&
        self.$refs.video.removeEventListener("timeupdate", self._currentTime);
      self.$refs.video.removeEventListener &&
        self.$refs.video.removeEventListener("canplay", self._durationTime);
    },
    _currentTime() {
      const self = this;
      let currentTime = self.$refs.video.currentTime;
      let duration = self.$refs.video.duration;
      self.timeNow = parseInt(currentTime);
      // console.log(currentTime, duration)
      this.time = (currentTime / duration) * 100;
      var timeTxt = this.turnTime(
        parseInt(this.timeDuration * (this.time / 100))
      );
      this.timeTxt = timeTxt ? timeTxt : "00";
    },
    _durationTime() {
      const self = this;
      var timeDuration = parseInt(self.$refs.video.duration);
      self.timeDuration = timeDuration ? timeDuration : "00";
    },
    onError() {
      console.log("视频加载错误");
      if (this.errorText === "视频加载正在尝试重连")
        this.errorText = "重连失败";
      //   this.isError = true;
      this.isSuccess = this.isLoading = false;
      let i = 10;
      window.restateTime = setInterval(() => {
        if (i < 1) {
          clearInterval(window.restateTime);
          i = 10;
        }
        this.errorText = i-- + "秒后重连";
      }, 1000);
      window.restartErrorTimer = setTimeout(() => {
        this.onRestart();
        this.errorText = "重连中";
      }, 10000);
    },
    onLoadStart() {
      console.log("开始视频请求数据", this.playSrc);
      //   this.isPlay = true
      window.loadstartTimer && clearTimeout(window.loadstartTimer);
      window.loadstartTimer =
        (() => {
          this.onRestart();
        },
        10000);
    },
    onCanPlayThrough() {
      if (!this.myPlayer) return;
      this.isSuccess = true;
      this.isLoading = false;
      this.isError = false;
      window.restartErrorTimer && clearTimeout(window.restartErrorTimer);
      window.restartStalledTimer && clearTimeout(window.restartStalledTimer);
      window.loadstartTimer && clearTimeout(window.loadstartTimer);
      this.myPlayer.volume(this.volume / 100);
      this.myPlayer.play();
    },
    onWaiting() {
      // console.log("等待数据");
      if (!this.isError) this.isLoading = true;
    },
    onTimeUpdate() {
      // console.log(this.myPlayer.video.currentTime, this.duration());

      if (!this.myPlayer) return;
      if (this.oldCurrentTime !== this.myPlayer.video.currentTime) {
        window.restartErrorTimer && clearTimeout(window.restartErrorTimer);
        window.restartStalledTimer && clearTimeout(window.restartStalledTimer);
        window.loadstartTimer && clearTimeout(window.loadstartTimer);
        this.isSuccess = true;
      }
      if (this.oldCurrentTime !== this.myPlayer.video.currentTime)
        this.isError = false;
      this.isLoading =
        this.oldCurrentTime === this.myPlayer.video.currentTime && !this.isError
          ? true
          : false;
      this.oldCurrentTime = this.myPlayer.video.currentTime;
      window.TimeUpdateTimer && clearTimeout(window.TimeUpdateTimer);
      window.TimeUpdateTimer = setTimeout(() => {
        if (!this.isError) this.isLoading = true;
      }, 1000);
      window.restartTimer && clearTimeout(window.restartTimer);
      window.restartTimer = setTimeout(() => {
        if (!this.isPlay) return;
        console.log("正在尝试重连");
        this.onRestart();
        this.errorText = "正在尝试重连";
      }, 10000);
    },
    onPause() {
      this.isPlay = false;
    },
    onStalled() {
      if (this.errorText === "正在尝试重连") this.errorText = "重连失败";
      this.errorText = "网络异常";
      let i = 10;
      window.restateTime = setInterval(() => {
        if (i < 1) {
          clearInterval(window.restateTime);
          i = 10;
        }
        this.errorText = i-- + "秒后重连";
      }, 1000);
      this.isError = true;
      this.isSuccess = this.isLoading = false;
      window.restartStalledTimer = setTimeout(() => {
        this.onRestart();
        this.errorText = "重连中";
      }, 10000);
    },
    createDpayer() {
      this.closePlayer();
      //   this.isPlay = true;
      this.isSuccess = false;
      this.isError = false;
      if (this.isLive && this.playSrc) {
        this.$nextTick(() => {
          const _this = this;
          let customType = {}; // 修复：声明 customType，避免未定义
          this.isLoading = true;
          this.myVideoType = this.$ryan.getSuffix(this.playSrc);
          let videoType = "customFlv";
          if (
            this.myVideoType.suffix === "customFlv" ||
            this.myVideoType.suffix === "flv"
          ) {
            customType = {
              customFlv: (video, player) => {
                _this.flvPlayer = window.flvjs.createPlayer({
                  type: "flv",
                  url: this.playSrc,
                });
                _this.flvPlayer.attachMediaElement(video);
                _this.flvPlayer.load();
                _this.flvPlayer.play();
              },
            };
            videoType = "customFlv";
          } else {
            videoType = this.myVideoType.suffix;
          }
          if (!window.dplayerList) window.dplayerList = [];
          window.dplayerList.forEach((player) => {
            player.closed = true;
          });
          this.myPlayer = new DPlayer({
            container: document.querySelector("#dplayer"),
            autoplay: true,
            live: true,
            video: {
              url: this.playSrc,
              type: videoType,
              customType: customType,
            },
          });
          window.dplayerList.push(this.myPlayer);
          this.myPlayer.on(
            "play",
            function () {
              _this.isPlay = true;
            }.bind(this.myPlayer)
          );
          this.myPlayer.on("loadstart", this.onLoadStart.bind(_this));
          this.myPlayer.on(
            "canplaythrough",
            function (dplayer) {
              this.onCanPlayThrough.bind(this)();
              cls(dplayer, _this);
            }.bind(this, this.myPlayer)
          );
          this.myPlayer.on("waiting", this.onWaiting.bind(_this));
          this.myPlayer.on(
            "timeupdate",
            function () {
              _this.onTimeUpdate.bind(_this)();
              try {
                cls(this, _that);
              } catch (err) {}
            }.bind(this.myPlayer)
          );
          this.myPlayer.on("error", this.onError.bind(_this));
          this.myPlayer.on("stalled", this.onStalled.bind(_this));
          this.myPlayer.on("pause", this.onPause.bind(_this));
          // this.myPlayer.on('play', () => {
          //     _this.isPlay = true
          //     console.log(new Date().getTime())
          //     window.onPlayTimeout = setTimeout(() => {
          //         console.log(new Date().getTime())

          //         _this.isPlay = false
          //     }, 3000)
          // })
          this.myPlayer.on("playing", () => {
            _this.isPlay = true;
          });
          this.myPlayer.on(
            "progress",
            function () {
              cls(this, _this);
            }.bind(this.myPlayer)
          );
          function cls(dplayer, that) {
            if (dplayer.closed) {
              dplayer.destroy();
              window.dplayerList = window.dplayerList.filter(
                (player) => player != dplayer
              );
              that.isPlay = true;
            }
          }
          this.oldCurrentTime = 0;
          [
            ".dplayer-mask",
            ".dplayer-controller-mask",
            ".dplayer-bezel",
            ".dplayer-controller",
            ".dplayer-notice",
          ].forEach((sel) => {
            const el = document.querySelector(sel);
            if (el) el.remove();
          });
        });
      }
    },
    closePlayer() {
      if (this.flvPlayer) {
        this.flvPlayer.destroy();
        this.flvPlayer = null;
      }
      if (this.myPlayer) {
        this.myPlayer.destroy();
        this.myPlayer = null;
      }
      clearInterval(window.tooltipTime);
      clearTimeout(window.videoMoveTimer);
      clearTimeout(window.restartErrorTimer);
      clearTimeout(window.TimeUpdateTimer);
      clearTimeout(window.restartTimer);
      clearTimeout(window.restartStalledTimer);
      // window.player = null;
    },
    logoImgShow(arr) {
      //logo图的展示方式
      this.$nextTick(() => {
        setTimeout(() => {
          arr.forEach((item, index) => {
            let divWrap = this.$refs.video_wrap;
            if (!divWrap) return;
            let divStyle = getComputedStyle(divWrap, null),
              divWidth = parseInt(divStyle.width),
              divHeight = parseInt(divStyle.height),
              newDivW = ((divWidth / 100) * item.width).toFixed(1), //宽
              newDivH = ((divWidth / 100) * item.height).toFixed(1), //高
              newDivL = ((divWidth / 100) * item.xpos).toFixed(1), //left值
              newDivT = ((divHeight / 100) * item.ypos).toFixed(1); //top值
            let ele = document.getElementsByClassName("videoLogo");
            ele[index].style.width = newDivW + "px";
            ele[index].style.height = newDivH + "px";
            ele[index].style.left = newDivL + "px";
            ele[index].style.top = newDivT + "px";
            ele[index].style.backgroundImage = `url(${item.image})`;
          });
        }, 100);
      });
    },
    livingLogo() {
      //得到直播logo接口
      if (!this.logoImg) {
        this.$axios
          .post("/", {
            service: "Watermark.GetWatermark",
            device: 1,
          })
          .then((response) => {
            let res = response.data.data;
            if (res.code == 0) {
              this.logoImg = res.info;
              this.logoImgShow(this.logoImg);
            }
          });
      } else {
        this.logoImgShow(this.logoImg);
      }
    },
    minStopOrPlay() {
      //小窗直播的暂停与播放
      if (this.moveFlag) {
        this.myPlayer.toggle();
      }
    },
  },
  created() {
    this.isLoading = this.playSrc ? true : false;
    var _this = this;
    let volume = localStorage.getItem("volume");
    if (volume) {
      volume = Number(volume);
      if (volume === NaN) {
        this.volume = 50;
        localStorage.setItem("volume", 50);
      } else {
        this.volume = volume;
      }
    } else {
      this.volume = 50;
      localStorage.setItem("volume", 50);
    }
    window.onclick = function () {
      _this.isClarity = false;
    };

    window.onresize = function () {
      var isFull =
        document.fullscreenElement ||
        document.mozRequestFullScreen ||
        document.webkitRequestFullscreen;
      if (isFull === undefined) {
        _this.isFullScreen = false;
      }
      _this.logoImgShow(_this.logoImg);
    };
  },
  mounted() {
    this.livingLogo();
    this.minMark = this.$refs.minMark;
    this.eleVideo = this.$refs.miniVideo;
    this.dragMiniVideo();
    window.addEventListener("scroll", this.handleScroll, true);
    this.$EventBus.$on("sendBarrager", (data) => {
      this.sendBarrage(data);
    });
    if (!this.playSrc) return;
    var _this = this;
    if (!_this.isLive) {
      _this.$refs.video.addEventListener("ended", function () {
        _this.stopPlay();
      });
    }
    if (!_this.isLive) {
      _this.$refs.video.oncanplay = function () {
        _this.isSuccess = true;
        _this.isError = false;
        _this.addEventListeners();
        _this.timeDuration = parseInt(_this.$refs.video.duration);
        _this.timeDurTxt = _this.turnTime(_this.timeDuration);
        _this.play();
        // currentTime || duration
        // console.log(_this.$refs.video.duration)
      };
      _this.$refs.video.onerror = function () {
        _this.isError = true;
        _this.isSuccess = false;
      };
    }
    _this.$refs.video_wrap.ondblclick = function () {
      if (_this.isFullScreen) {
        _this.exitFullscreen();
      }
    };

    window.tooltipTime = setInterval(function () {
      const poppers = document.querySelectorAll(".el-tooltip__popper");
      poppers.forEach(function (popper) {
        // 只绑定一次事件，避免重复绑定
        if (!popper._hoverBinded) {
          popper.addEventListener("mouseenter", function () {
            const btnWrap = document.querySelector(
              "#video .video-wrap .video-btn-wrap"
            );
            if (btnWrap) {
              btnWrap.style.transform = "translateY(0)";
            }
          });
          popper._hoverBinded = true;
        }
      });
      var length = _this.isLive ? 1 : 2;
      if (poppers.length === length) clearInterval(window.tooltipTime);
    }, 1);
  },
  beforeDestroy() {
    //在页面离开前销毁前
    window.removeEventListener("scroll", this.handleScroll, true); //在页面销毁前监听滑动事件
  },
  destroyed() {
    // this.isLive ? this.dispose() : this.removeEventListeners();
    // this.isLive ? this.dispose&&this.dispose() : false;
    setTimeout(this.closePlayer, 200);
  },
  watch: {
    playObj: {
      handler(val, old) {
        window.localStorage.setItem("pull", val);
        if (val !== old) {
          this.createDpayer();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
#barragediv {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  overflow: hidden;
}
#barrageLayer1,
#barrageLayer2,
#barrageLayer3,
#barrageLayer0 {
  width: 100%;
  position: absolute;
  right: 0;
  height: 20px;
  font-size: 18px;
  color: #fff;
}

#barrageLayer0 {
  top: 5px;
}
#barrageLayer1 {
  top: 30px;
}
#barrageLayer2 {
  top: 55px;
}
#barrageLayer3 {
  top: 80px;
}
.videoLogo {
  position: absolute;
  background-size: 100% 100%;
}
.min-video {
  position: fixed;
  width: 456px !important;
  height: 259px !important;
  right: 100px;
  top: 400px;
  z-index: 9;
}
.min-mark {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  cursor: move;
  background-color: transparent;
}
.min-content {
  position: relative;
  padding: 14px 16px;
  height: 100%;
  box-sizing: border-box;
  z-index: 101;
}
.min-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top-left {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  user-select: none;
}
.min-bottom i {
  position: absolute;
  bottom: 14px;
  width: 40px;
  height: 40px;
}
.icon-play {
  background: url(https://sta.cranemarsh.com/web/assets/yy/img/minscreen-play.png);
}
.icon-stopplay {
  background: url(https://sta.cranemarsh.com/web/assets/yy/img/minscreen-pause.png);
}
.top-right {
  width: 20px;
  height: 20px;
  background: url(https://sta.cranemarsh.com/web/assets/yy/img/minscreen-close.png)
    no-repeat center;
  background-size: 20px 20px;
}
#video {
  width: 100%;
  height: 100%;
  /* position:relative; */
}

.no-success {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  /* z-index:-1; */
}

.no-success .wrap {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
}

.no-success .wrap .icon {
  margin-top: 25px;
  vertical-align: top;
  width: 335px;
  height: 11px;
  background-image: url("./../assets/img/jindutiao.gif");
  background-repeat: no-repeat;
  background-size: 100%;
}

.no-success.error .wrap .icon {
  width: 187px;
  height: 192px;
  background-image: url("./../assets/images/error-huohu.png");
}

.no-success .wrap .msg {
  position: absolute;
  bottom: 32px;
  left: 50%;
  margin-left: -76px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #fffefe;
}

.no-success.error .wrap .el-button {
  padding: 0;
  width: 250px;
  box-sizing: border-box;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 16px;
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
  background-color: transparent;
  transition: background-color 0.33s ease-in-out, color 0.33s ease-in-out;
  margin-top: 71px;
}

.no-success.error .wrap .el-button:hover {
  color: #fff;
  background-color: var(--primary-color);
}

#video .video-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000;
  overflow: hidden;
}

/* #video .video-wrap:hover .video-btn-wrap {
        transform: translateY(0);
        transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
    } */

#video .video-wrap .video-btn-wrap.show {
  transform: translateY(0);
  transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
}

#video .video-wrap .video-play-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 110px;
  height: 110px;
  margin-left: -55px;
  margin-top: -55px;
  background-image: url("./../assets/images/play-icon-xl.png");
  background-repeat: no-repeat;
  background-size: 100%;
  cursor: pointer;
  z-index: 11;
}
#video .video-wrap .video-play-icon.hide {
  display: none !important;
}

#video .video-wrap .video-play-icon:hover {
  background-image: url("./../assets/images/play-icon-xl-hl.png");
}

#video .video-wrap .video-btn-wrap {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 40px;
  left: 0;
  right: 0;
  z-index: 11;
  background: rgba(0, 0, 0, 0.3);
  /* padding: 0 10px; */
  transition: transform 0.25s ease-out, -webkit-transform 0.25s ease-out;
}

#video .video-wrap .video-btn-wrap.hide {
  transform: translateY(100%);
}

#video .video-wrap .video-btn-wrap .time-slider {
  position: absolute;
  bottom: 100%;
  /* width: 100%; */
  left: 10px;
  right: 10px;
  height: 2px;
  line-height: 2px;
}

#video .video-wrap .video-btn-wrap .icon-btn {
  display: inline-block;
  vertical-align: middle;
  width: 24px;
  height: 22px;
  line-height: 36px;
  cursor: pointer;
  background-image: url("./../assets/images/video-icons.png");
}

#video .video-wrap .video-btn-wrap .video-btn-left {
  float: left;
  margin-top: 8.5px;
  user-select: none;
}
.video-btn-middle {
  width: 50px;
  height: 100%;
  float: left;
  position: relative;
}
.play-or-stop {
  display: none;
  position: absolute;
  top: -20px;
  left: -216px;
  color: #fff;
  padding: 6px 8px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.4);
}
.mute-or-sound {
  display: none;
  position: absolute;
  top: -20px;
  left: -190px;
  color: #fff;
  padding: 6px 8px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.4);
}
.fullScreen-or-no {
  font-size: 12px;
  display: none;
  position: absolute;
  top: -20px;
  left: -40px;
  color: #fff;
  padding: 6px 8px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.4);
}
#video .video-wrap .video-btn-wrap .video-btn-left .icon-btn {
  /* background-image: url("./../assets/images/video-icon.png"); */
  background-size: 100%;
  background-repeat: no-repeat;
}

#video .video-wrap .video-btn-wrap .video-btn-left .icon-btn:first-child {
  /* background-position: -212px 8px; */
  width: 20px;
  height: 23px;
  background-image: url("./../assets/images/zanting.png");
  margin-left: 9px;
}

/* #video .video-wrap .video-btn-wrap .video-btn-left .icon-btn:first-child:hover {
        background-image: url('./../assets/images/zanting-hl.png');
    } */

#video .video-wrap .video-btn-wrap .video-btn-left .icon-btn:nth-child(2) {
  width: 20px;
  height: 22px;
  background-image: url("./../assets/images/bofan.png");
  margin-left: 9px;
  /* background-position: -25px 8px; */
}

/* #video .video-wrap .video-btn-wrap .video-btn-left .icon-btn:nth-child(2):hover {
        background-image: url('./../assets/images/bofan-hl.png');
    } */

#video .video-wrap .video-btn-wrap .video-btn-left .icon-btn:nth-child(3) {
  /* background-position: -260px 6px; */
  width: 24px;
  height: 22px;
  margin-left: 32px;
  background-image: url("./../assets/images/shuaxin.png");
  display: none;
}

#video
  .video-wrap
  .video-btn-wrap
  .video-btn-left
  .icon-btn:nth-child(3):hover {
  /* background-position: -109px 6px; */
  background-image: url("./../assets/images/shuaxin-hl.png");
}
#video .video-wrap .video-btn-wrap .video-btn-left .icon-btn:nth-child(4) {
  margin-right: 10px;
  /* background-position: -72px -72px; */
  background-image: url("./../assets/images/horn-icon.png");
  background-position: center;
  background-repeat: no-repeat;
}
#video .video-wrap .video-btn-wrap .video-btn-left .mute {
  background: url("./../assets/images/horn-mute-icon.png") !important;
}
#video .video-wrap .video-btn-wrap .video-btn-left .el-slider {
  display: inline-block;
  margin-right: 25px;
  width: 130px;
  height: 4px;
}
#video .video-wrap .video-btn-wrap .video-btn-left .time-info {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
  /* margin-top: 12px; */
  color: #fff;
}

#video .video-wrap .video-btn-wrap .video-btn-right {
  float: right;
  font-size: 16px;
  position: relative;
}

#video .video-wrap .video-btn-wrap .video-btn-right > * {
  float: left;
}

#video .video-wrap .video-btn-wrap .video-btn-right .icon-btn:first-child {
  margin-right: 10px;
  /* background-position: -72px -72px; */
  background-image: url("./../assets/images/horn-icon.png");
  background-position: center;
  background-repeat: no-repeat;
  display: none;
}
#video .video-wrap .video-btn-wrap .video-btn-right .danmu {
  margin-top: 11px;
  font-size: 14px;
  color: #fff;
  margin-right: 8px;
}
#video
  .video-wrap
  .video-btn-wrap
  .video-btn-right
  .icon-btn:first-child:hover {
  background-image: url("./../assets/images/horn-icon-hover.png");
}

#video .video-wrap .video-btn-wrap .video-btn-right .icon-btn:first-child.mute {
  background-image: url("./../assets/images/horn-mute-icon.png");
}

#video
  .video-wrap
  .video-btn-wrap
  .video-btn-right
  .icon-btn:first-child.mute:hover {
  background-image: url("./../assets/images/horn-mute-icon-hover.png");
}

#video .video-wrap .video-btn-wrap .video-btn-right .icon-btn:nth-child(3) {
  margin-left: 20px;
  display: inline-block;
  vertical-align: middle;
  width: 25px;
  height: 25px;
  background-image: url("./../assets/images/danmu.png");
  background-repeat: no-repeat;
  background-size: 100%;
  margin-top: 5.5px;
  margin-right: 20px;
}

#video
  .video-wrap
  .video-btn-wrap
  .video-btn-right
  .icon-btn:nth-child(3):hover {
  background-image: url("./../assets/images/danmu-hl.png");
}

#video
  .video-wrap
  .video-btn-wrap
  .video-btn-right
  .icon-btn.hiddle:nth-child(3) {
  background-image: url("./../assets/images/wudanmu.png");
}

#video
  .video-wrap
  .video-btn-wrap
  .video-btn-right
  .icon-btn.hiddle:nth-child(3):hover {
  background-image: url("./../assets/images/wudanmu-hl.png");
}

/* #video .video-wrap .video-btn-wrap .video-btn-right .el-slider {
        display: inline-block;
        margin-right: 25px;
        width: 130px;
        height: 4px;
    } */

#video .video-wrap .video-btn-wrap .video-btn-right .clarity {
  background-color: rgba(0, 0, 0, 0.8);
  color: #999;
  bottom: 43px;
  /* right: 51px; */
  right: 65px;
  position: absolute;
  text-align: center;
  padding: 4px 0;
}

#video .video-wrap .video-btn-wrap .video-btn-right .clarity .clarity-item {
  text-align: center;
  cursor: pointer;
  opacity: 0.6;
  padding: 9.5px 12px;
  white-space: nowrap;
  user-select: none;
}

#video
  .video-wrap
  .video-btn-wrap
  .video-btn-right
  .clarity
  .clarity-item.active,
#video
  .video-wrap
  .video-btn-wrap
  .video-btn-right
  .clarity
  .clarity-item:active,
#video
  .video-wrap
  .video-btn-wrap
  .video-btn-right
  .clarity
  .clarity-item:focus,
#video
  .video-wrap
  .video-btn-wrap
  .video-btn-right
  .clarity
  .clarity-item:hover {
  color: var(--primary-color);
}

#video .video-wrap .video-btn-wrap .video-btn-right .select-clarity {
  color: #fff;
  opacity: 0.8;
  margin-top: 10px;
  margin-right: 27px;
  cursor: pointer;
  width: 58px;
  text-align: center;
  user-select: none;
  display: none;
}

#video .video-wrap .video-btn-wrap .video-btn-right .select-clarity:hover {
  color: var(--primary-color);
}

#video .video-wrap .video-btn-wrap .video-btn-right .icon-btn:last-child {
  background-image: url("./../assets/images/full-icon.png");
  background-position: center;
  background-repeat: no-repeat;
  margin-right: 9px;
  margin-top: 10px;
  background-size: 100%;
}

/* #video .video-wrap .video-btn-wrap .video-btn-right .icon-btn:last-child:hover {
        background-image: url('./../assets/images/full-icon-hover.png');
    } */

#video .video-wrap .video-btn-wrap .video-btn-right .icon-btn:last-child.full {
  /* background-position: 0 -108px; */
  background-image: url("./../assets/images/narrow-icon.png");
}

#video
  .video-wrap
  .video-btn-wrap
  .video-btn-right
  .icon-btn:last-child.full:hover {
  /* background-position: -36px -108px; */
  background-image: url("./../assets/images/narrow-icon-hover.png");
}

#video .video-wrap .error {
  position: absolute;
  color: #fff;
}

.myVideo-dimensions {
  width: 100%;
  height: 100%;
}

/* #video .head-live {
        float: left;
        background: rgba(0, 0, 0, 0.5);
        width: 170px;
        height: 576px;
    }

    #video .head-live .head-live-list {
        box-sizing: border-box;
        padding: 2px 8px;
        height: 576px;
    }

    #video .head-live .head-live-list .head-live-item {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 16.6%;
        border-radius: 5px;
        cursor: pointer;
    }

    #video .head-live .head-live-list .head-live-item.active::before {
        content: "";
        width: 0;
        height: 0;
        border-top: 7px solid transparent;
        border-right: 8px solid var(--primary-color);
        border-bottom: 7px solid transparent;
        position: absolute;
        top: 50%;
        left: -7px;
        margin-top: -5px;
    }

    #video .head-live .head-live-list .head-live-item:hover img,
    #video .head-live .head-live-list .head-live-item.active img {
        border: 3px solid var(--primary-color);
    }

    #video .head-live .head-live-item img {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        border: 3px solid transparent;
    } */
/* #ckplayer {
        width: 100%;
        height: 100%;
    } */
#myVideo {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>

<style>
#video .video-wrap .time-slider .el-slider__bar,
#video .video-wrap .time-slider .el-slider__runway {
  height: 2px;
}

#video .time-slider .el-slider__bar {
  border-radius: 0;
}

#video .el-slider__runway {
  background-color: #ccc;
  margin: -1px;
}

#video .video-wrap .video-btn-wrap .time-slider:hover .el-slider__bar,
#video .video-wrap .video-btn-wrap .time-slider:hover .el-slider__runway {
  height: 4px;
}

#video
  .video-wrap
  .video-btn-wrap
  .time-slider:hover
  .el-slider__button-wrapper {
  display: initial;
}

#video .time-slider .el-slider__button-wrapper {
  display: none;
}

#video .video-btn-right .el-slider__bar,
#video .video-btn-right .el-slider__runway {
  height: 4px;
}

#video .video-wrap .el-slider__bar {
  background-color: var(--primary-color);
}

#video .video-wrap .el-slider__button {
  width: 6px;
  height: 6px;
  border: 2px solid #fff;
  background-color: var(--primary-color);
}

#video .video-wrap .video-btn-wrap .time-slider .el-slider__runway {
  margin: 0;
  border-radius: 0;
}

/* .vjs-modal-dialog .vjs-modal-dialog-content {
        box-sizing: border-box;
    }

    .vjs-error .vjs-error-display .vjs-modal-dialog-content {
        display: none;
    }

    .vjs-seeking .vjs-loading-spinner:after, .vjs-waiting .vjs-loading-spinner:after {
        display: none;
    }

    #video .vjs-control-text {
        display: none;
    }

    #video .vjs-error .vjs-error-display:before {
        display: none;
    } */

#video .video-wrap video {
  width: 100%;
  height: 100%;
}
.logo-living {
  width: 235px;
  height: 60px;
  display: inline-block;
  background-image: var(--images-logo);
  background-size: 100%;
}
.loading-words {
  margin-top: 24px;
  color: #fffefe;
}
#dplayer {
  height: 100%;
}
/* #video #myVideo {
        width: 100%;
        height: 100%;
    } */
.enter-studio {
  position: absolute;
  width: 22rem;
  height: 4rem;
  border: 0.1rem solid var(--primary-color);
  border-radius: 0.3rem;
  color: var(--primary-color);
  font-weight: 600;
  top: 50%;
  left: 50%;
  margin-left: -11rem;
  margin-top: 7rem;
  text-align: center;
  line-height: 4rem;
  font-size: 1.6rem;
  z-index: 11;
}
.enter-studio:hover {
  background: var(--primary-color);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/base/video.vue